import { render, staticRenderFns } from "./ManageHotelNav.vue?vue&type=template&id=5843a8e4"
import script from "./ManageHotelNav.vue?vue&type=script&lang=js"
export * from "./ManageHotelNav.vue?vue&type=script&lang=js"
import style0 from "./ManageHotelNav.vue?vue&type=style&index=0&id=5843a8e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports